export const KEEP_ALIVE = 'keep-alive';
//# sourceMappingURL=tags.js.map